import React from 'react';
import styled, { css } from 'styled-components';

import Filters from '@lt/components/icons-react/rebrand/Filter';
import { useTranslation } from '@lt/localization';

import {
  FloatingPanelButton,
  BottomButtonText,
  ButtonContainer,
} from '../styles';

import {
  FILTERS_COUNTER_DATA_TEST_ID,
  SHOW_FILTERS_BUTTON_DATA_TEST_ID,
} from './constants';

interface IShowFiltersButton {
  count: number;
  isFirstButton: boolean;
  toggleFilters: () => void;
}

const ShowFiltersButton = ({
  isFirstButton,
  toggleFilters,
  count,
}: IShowFiltersButton) => {
  const { t } = useTranslation();

  return (
    <Button
      $isFirstButton={isFirstButton}
      type="button"
      onClick={toggleFilters}
      data-testid={SHOW_FILTERS_BUTTON_DATA_TEST_ID}
    >
      <ButtonContainer>
        <div style={{ height: '16px' }}>
          {count > 0 && (
            <Counter data-testid={FILTERS_COUNTER_DATA_TEST_ID}>
              {count}
            </Counter>
          )}
          <StyledFiltersIcon />
        </div>
        <BottomButtonText>{t('hotel.filters.title')}</BottomButtonText>
      </ButtonContainer>
    </Button>
  );
};

const Button = styled(FloatingPanelButton)<{ $isFirstButton: boolean }>`
  ${({ $isFirstButton }) =>
    $isFirstButton &&
    css`
      border-top-left-radius: var(--border-radius);
      border-bottom-left-radius: var(--border-radius);
    `}
`;

const Counter = styled.span`
  position: absolute;
  transform: translate(11px, -4px);
  width: 16px;
  height: 16px;
  background-color: var(--secondary);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--white);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;

const StyledFiltersIcon = styled(Filters)`
  height: 16px;
`;

export default ShowFiltersButton;
